import { IconProps } from '../icon-props-interface';
import '../icons.scss';

const IconCircleArrowDown = ({ color = 'var(--color-semantic-danger)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0)">
                <path d="M12.5872 8.23699L12.3445 7.99252C12.2681 7.91617 12.1664 7.87411 12.0577 7.87411C11.9492 7.87411 11.8474 7.91617 11.771 7.99252L9.00148 10.7621L6.2288 7.98944C6.15251 7.91309 6.05073 7.87109 5.94215 7.87109C5.83356 7.87109 5.73173 7.91309 5.65538 7.98944L5.41253 8.23241C5.25442 8.3904 5.25442 8.64777 5.41253 8.80577L8.71375 12.1189C8.79004 12.1951 8.89169 12.2489 9.00124 12.2489H9.00251C9.11116 12.2489 9.21281 12.1951 9.2891 12.1189L12.5872 8.81475C12.6636 8.73846 12.7056 8.63373 12.7057 8.52514C12.7057 8.4165 12.6636 8.31321 12.5872 8.23699Z" fill="#FC8664" />
            </g>
            <circle cx="9" cy="9" r="8.5" stroke={color} />
            <defs>
                <clipPath id="clip0">
                    <rect width="7.41176" height="7.41176" fill="white" transform="translate(5.29395 6.35352)" />
                </clipPath>
            </defs>
        </svg>
    </div>
);

export default IconCircleArrowDown;
